import { deleteArticleActions } from "../actions";
import { withNoResult } from "./noResult";

const deleteArticle = withNoResult(deleteArticleActions);

export { deleteArticle };
